module.exports = "<div style=\"text-align:center\">\n    <h1>{{title}}</h1>\n    <h2>Denne side er under udvikling</h2>\n</div>\n\n  \n"


//////////////////
// WEBPACK FOOTER
// /home/hkk/source/crazyaboutmath/src/app/fractions/fractions.component.html
// module id = ../../../../../src/app/fractions/fractions.component.html
// module chunks = main